export const ROUTES = {
  LIST: "LIST",
  USERS: "USERS",
};
